export enum CrudStoreItemOnboarding {
  AMSSearch = 'AMSSearch',
  AplAmsLatamSearch = 'AplAmsLatamSearch',
  SPRSearch = 'SPRSearch',
  SimplePartnerRegistration = 'SimplePartnerRegistration',
  RequestTemplates = 'RequestTemplates', // TODO: change with service api OnboardingTemplateApi
  ActionTemplates = 'ActionTemplates',
  OnboardingProcessValues = 'OnboardingProcessValues',
  ActionTransitionsTemplate = 'ActionTransitionsTemplate',
  RequestList = 'RequestList',
  ContractRequestList = 'ContractRequestList',
  RetailOnboardingRequestsList = 'RetailOnboardingRequestsList',
  Specializations = 'Specializations',
  Actions = 'Actions',
  RequestFiles = 'RequestFiles',
  ProcessesProgress = 'ProcessesProgress',
  ActionTransitions = 'ActionTransitions',
  CollectedData = 'CollectedData',
  RequestHistory = 'RequestHistory',
  UserMapping = 'UserMapping',
  UserMappingTree = 'UserMappingTree',
  NotificationTemplatesUniqList = 'NotificationTemplatesUniqList',
  NotificationTemplatesWrappers = 'NotificationTemplatesWrappers',
  ContractsList = 'ContractsList',
  RequestNotifications = 'RequestNotifications',
  RequestForms = 'RequestForms',
  ActionsForGrid = 'ActionsForGrid',
  LNRFormData = 'LNRFormData',
  ContractsFormData = 'ContractsFormData',
  RequestorFillData = 'RequestorFillData',
  PFPOnboardingRequests = 'PFPOnboardingRequests',
  ExceptionsList = 'ExceptionsList',
  ExceptionsReasonsList = 'ExceptionsReasonsList',
  ExceptionGroups = 'ExceptionGroups',
  ExceptionsRequestsList = 'ExceptionsRequestsList',
  SpecializationProgramElements = 'SpecializationProgramElements',
  UniqNotificationTemplates = 'UniqNotificationTemplates',
  ExceptionsDomains = 'ExceptionsDomains',
  OnboardingUsers = 'OnboardingUsers',
  ActionsExpirations = 'ActionsExpirations',
  PartnerShipLA = 'PartnerShipLA',
  RequestorLAFillData = 'RequestorLAFillData',
  PartnerShipNA = 'PartnerShipNA',
  MyActionsPage = 'MyActionsPage',
  ActionsExpirationsCount = 'ActionsExpirationsCount',
  RetailOnboardingRequests = 'RetailOnboardingRequests',
  RetailOnboardingExtRequests = 'RetailOnboardingExtRequests',
  RolesMapping = 'RolesMapping',
  ContractValidateAddition = 'ContractValidateAddition',
  RetailExceptionsList = 'RetailExceptionsList',
  RetailExceptionsReasonsList = 'RetailExceptionsReasonsList',
  OnboardingSqlTriggersDesc = 'OnboardingSqlTriggersDesc',
  OnboardingSqlTriggersFieldsDesc = 'OnboardingSqlTriggersFieldsDesc',
  BpRegDashboard = 'BpRegDashboard',
  RegistrFormsConfig = 'RegistrFormsConfig',
  BPRegDetails = 'BPRegDetails',
  BPReconfirmationDetails = 'BPReconfirmationDetails',
  BPRegistrationRequestList = 'BPRegistrationRequestList',
  BPRegistrationListView = 'BPRegistrationListView',
  BPRegPartnerSearch = 'BPRegPartnerSearch',
  BPRegistrationStatusCheckNew = 'BPRegistrationStatusCheckNew',
  BPBrokenRegs = 'BPBrokenRegs',
  BPBrokenRegsCount = 'BPBrokenRegsCount',
  BPReconfirmationRequestList = 'BPReconfirmationRequestList',
  BPReconfirmationDetail = 'BPReconfirmationDetail',
  LNRChampion = 'LNRChampion',
  BackupUsersList = 'BackupUsersList',
  BPSimpleRegistration = 'BPSimpleRegistration',
  SimplePartnerRegistrationRequests = 'SimplePartnerRegistrationRequests',
  PartnerRegistrations = 'PartnerRegistrations',
  UploadHistory = 'UploadHistory',
  PartnerExclusionList = 'PartnerExclusionList',
  BPAllActive = 'BPAllActive',
  BPRegisteredActiveUsersView = 'BPRegisteredActiveUsersView',
  BPAllContacts = 'BPAllContacts',
  BPAllUser = 'BPAllUser',
  DSBReport = 'DSBReport',
  OnboardingDropdowns = 'OnboardingDropdowns',
  ExpirationTimersAdmin = 'ExpirationTimersAdmin',
}
